<template>
  <div id="container" class="store_st_search">
    <div v-if="!displayMain" id="searchResult">
      <div class="search_result">
        <div class="section fill">
          <div class="inner">
            <p class="result_txt">
              {{ $t('views.store.search.total')
              }}<em> {{ getSearchTotalCount || 0 }} </em
              >{{ $t('views.store.search.1481') }}
            </p>
            <BaseSortBar
              :current-page-title="`검색`"
              :current-book-count="getSearchTotalCount"
              :current-sort-value="currentSortValue"
              :landscape="landscapeMode"
              @changeMode="viewModeChange"
              @sorting="changeSortOrder"
            />

            <div
              class="eplist item_columns_grid"
              :class="[landscapeMode ? 'item_landscape' : 'item_image']"
            >
              <ul class="item_list">
                <BaseBook
                  v-for="(book, idx) in getSearchList"
                  :key="idx"
                  class="limitWidth"
                  :book="book"
                  :landscape="landscapeMode"
                  :display-price="true"
                />
                <Spinner
                  :active="getSearchLoading"
                  loader="bars"
                  color="#007FA2"
                  background-color="#ffffff"
                  :opacity="0.7"
                  :is-full-page="false"
                  :width="128"
                  :height="128"
                />
              </ul>

              <Pagination
                :current-page="currentPage"
                :total-count="getSearchTotalCount"
                :item-per-page="booksOnPage"
                @paginate="paginate"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="displayMain" id="searchDefault">
      <div id="searchEmpty">
        <div class="section fill">
          <div class="inner">
            <div class="empty flex-center">
              <div class="not_found_txt">
                <p class="txt">
                  <em>"{{ getSearchTxt }}"</em
                  >{{ $t('views.store.search.8317') }}
                </p>
                <div class="guide_txt">
                  <p>{{ $t('views.store.search.5405') }}</p>
                  <p>{{ $t('views.store.search.6783') }}</p>
                  <p>{{ $t('views.store.search.4995') }}</p>
                  <p>{{ $t('views.store.search.6634') }}</p>
                </div>
                <div class="find_info">
                  <p>찾으시는 도서가 없으시다면?</p>
                  <a
                    href="https://walla.my/v/IbKGZEh80uuZRHZvvSJ2"
                    target="_blank"
                    >도서 요청하기</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="section fill pb">
        <div class="inner">
          <h2>
            <router-link
              :to="{ name: 'books_category', params: { category: 'new' } }"
              class="sec_title"
              ><span>{{
                $t('views.store.bookdetail.newrelease')
              }}</span></router-link
            >
          </h2>
          <div class="eplist item_columns_grid">
            <ul class="item_list">
              <BaseBook
                v-for="(book, idx) in newBooks"
                v-show="idx < 6"
                :key="idx"
                :book="book"
              />
            </ul>
          </div>
        </div>
      </div> -->
      <!-- <div class="section fill">
        <div class="inner">
          <h2>
            <router-link
              :to="{ name: 'books_category', params: { category: 'popular' } }"
              class="sec_title"
              ><span>{{ $t('views.store.search.4755') }}</span></router-link
            >
          </h2>
          <div class="eplist item_columns_grid">
            <ul class="item_list" style="border: none;">
              <BaseBook
                v-for="(book, idx) in popularBooks"
                v-show="idx < 6"
                :key="idx"
                :book="book"
              />
            </ul>
          </div>
        </div>
      </div> -->
    </div>

    <!-- 헬프 데스크 START -->
    <!-- <HelpDesk /> -->
    <!-- 헬프 데스크 END -->
  </div>
</template>

<script>
import BaseBook from '@/components/base/BaseBook.vue'
import { mapState, mapGetters } from 'vuex'
import BaseSortBar from '@/components/base/BaseSortBar.vue'

const generateYearOptions = (startYear) => {
  const currentYear = new Date().getFullYear()
  const years = []

  startYear = startYear || 1980
  while (startYear <= currentYear) {
    years.push(startYear++)
    //startYear++
  }
  return years
}

export default {
  name: 'Search',

  // components: { BaseBook, HelpDesk },
  components: { BaseBook, BaseSortBar },
  data() {
    return {
      query: '',

      keyword: this.$route.query.keyword || '',
      searchTp: this.$route.query.searchTp || '',
      currentSortValue: this.$route.query.sort || 'SA',
      currentPage: parseInt(this.$route.query.page) || 1,
      booksOnPage: 15,

      searchTerm: '',
      landscapeMode: false,
      categoryFilter: 'all',
      showDetailSearch: false,
      showCategoryMenu: false,
      years: generateYearOptions(1980),
      showStartYearOptions: false,
      showEndYearOptions: false,
      showDepartmentOptions: false,
      hasResults: false,
      topSearchSection: 1,
      topSearchTimer: ''
    }
  },
  computed: {
    ...mapState(['books']),
    ...mapGetters([
      'getSearchTxt',
      'getSearchTotalCount',
      'getSearchLoading',
      'getSearchTp',
      // campusbook
      'getStoreSearchMain',
      'isStoreSearchLoading',
      'getSearchList',
      'getStoreSeachTotalCount',
      'getMainCategories'
    ]),
    newBooks() {
      if (!this.getStoreSearchMain) {
        return []
      }
      return this.getStoreSearchMain.newBooks || []
    },
    popularBooks() {
      if (!this.getStoreSearchMain) {
        return []
      }
      return this.getStoreSearchMain.popularBooks || []
    },
    displayMain() {
      if (
        !this.getSearchLoading &&
        (this.getSearchList.length === 0 || !this.getSearchList)
      ) {
        return true
      }
      return false
    },
    displayNoSearchResults() {
      if (
        !this.isStoreSearchLoading &&
        this.searchTerm &&
        (!this.getSearchList || !this.getSearchList.length)
      ) {
        return true
      }
      return false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (!to.query.page || isNaN(parseInt(to.query.page))) {
      this.currentPage = 1
    } else {
      this.currentPage = parseInt(to.query.page)
    }
    next()
  },
  async mounted() {
    await this.$store.dispatch('fetchSearchList', {
      searchKeyword: this.keyword,
      pageNo: this.currentPage,
      searchTp: this.currentSortValue,
      searchTp2: this.searchTp
    })
  },
  methods: {
    viewModeChange(value) {
      this.landscapeMode = value
    },
    async changeSortOrder(sort) {
      if (this.currentPage === 1 && this.getSearchTp === sort.value) {
        return
      }
      this.currentPage = 1
      this.currentSortValue = sort.value
      await this.fetchSearchList(this.currentPage, this.currentSortValue)
      this.$router.push({
        name: 'search',
        query: {
          keyword: this.keyword,
          searchTp: this.searchTp,
          sort: this.currentSortValue,
          page: this.currentPage
        }
      })
    },

    async fetchSearchList(pageNo, searchTp) {
      this.currentPage = pageNo || 1

      await this.$store.dispatch('fetchSearchList', { pageNo, searchTp })
      this.$router.push({
        name: 'search',
        query: {
          keyword: this.keyword,
          searchTp: this.searchTp,
          sort: this.currentSortValue,
          page: this.currentPage
        }
      })
    },
    paginate(page) {
      if (this.currentPage === page) {
        return
      }
      this.currentPage = page
      this.$store.dispatch('fetchSearchList', {
        pageNo: this.currentPage,
        searchTp: this.currentSortValue
      })
      this.$router.push({
        name: 'search',
        query: {
          keyword: this.keyword,
          searchTp: this.searchTp,
          sort: this.currentSortValue,
          page: this.currentPage
        }
      })
    }
  }
}
</script>
<style src="@/assets/css/page_search.css" scoped></style>
<style lang="scss" scoped>
.search_result_filter {
  display: flex;
  justify-content: space-between;
}
.search_sort .search_result_filter .eplist_sort {
  margin-left: auto;
  margin-right: 24px;
}
.search_sort .search_result_filter .eplist_sort,
.search_sort .search_result_filter .eplist_listype {
  align-items: flex-end;
  align-self: flex-end;
  align-items: flex-end;
  position: static;
}
.store_st_search {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}
// @media (min-width: 768px) {
//   .limitWidth {
//     width: 13vw;
//     max-width: 120px;
//   }
// }
.period_label {
  height: 42px;
}
.search_favorite {
  min-height: 100px;
}

.box_btn {
  padding: 0px;
}
.section {
  .inner {
    padding-top: 0;
  }
}
.find_info {
  text-align: center;
  p {
    margin-top: 50px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #9b9b9b;
  }
  a {
    display: inline-block;
    background-color: #0f638f;
    border-radius: 15px;
    padding: 15px 60px;
    letter-spacing: -0.05px;
    font-size: 15px;
    color: #ffffff;
  }
}
.eplist.item_columns_grid.item_landscape .item_list > li + li {
  margin-top: 40px;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .eplist.item_columns_grid.item_image {
    margin-top: 20px;
  }
  .eplist.item_columns_grid.item_landscape .item_list {
    margin: 20px auto;
  }
}
</style>
